import { apiClient } from '@/lib/api-client';

/**
 * Admin Website Sections API. Sections belong to a page; the editor creates,
 * updates (dataJson + meta), reorders, and deletes them.
 */

export interface SectionWrite {
  pageId?: string;
  sectionType?: string;
  sortOrder?: number;
  title?: string | null;
  subtitle?: string | null;
  isVisible?: boolean;
  dataJson?: unknown;
}

const BASE = '/admin/website/sections';

export const createSection = async (payload: SectionWrite): Promise<{ id: string }> => {
  const { data } = await apiClient.post<{ id: string }>(BASE, payload);
  return data;
};

export const updateSection = async (id: string, payload: SectionWrite): Promise<void> => {
  await apiClient.patch(`${BASE}/${id}`, payload);
};

export const deleteSection = async (id: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${id}`);
};

/** Persist a new section order for a page. Body: ordered section ids. */
export const reorderSections = async (pageId: string, orderedIds: string[]): Promise<void> => {
  // Server schema (ReorderWebsiteSectionsRequestSchema) expects `orderedSectionIds`.
  await apiClient.post(`${BASE}/reorder/${pageId}`, { orderedSectionIds: orderedIds });
};
